import React, { useState, useEffect, useRef } from "react";
import { useForm } from 'react-hook-form';
import { useReactToPrint } from "react-to-print";
import Select from 'react-select'

// components
import {
  Container,
  Row,
  Col,
  Spinner,
  FormGroup,
  Input,
  Button
} from "reactstrap";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckDouble, faPrint, faTriangleExclamation, faUserShield } from "@fortawesome/free-solid-svg-icons";

// style
import "../../assets/css/loading.css";
import "../../assets/css/dashboard.css";

//helpers
import { formateDateApi } from "../../helpers/formats.js";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST } from "../../services/api_service.js";
import { getSessionCookie } from "../../services/session.js";

//Components
import { StatusOperacionaisTable } from "./components/StatusOperacionaisTable";

export default function DashBoard({ history }) {
  const session = getSessionCookie();

  const { register, errors, setValue } = useForm({ mode: "onBlur" });

  const [showLoading, setshowLoading] = useState(false);

  const [optionsRegional, setOptionsRegional] = useState([]);
  const [regionais, setRegionais] = useState([]);
  const [optionsModalidade, setOptionsModalidade] = useState([]);
  const [modalidade, setModalidade] = useState([]);

  const [inicio, setInicio] = useState(formateDateApi(moment(new Date()).startOf('month')));
  const [fim, setFim] = useState(formateDateApi(moment(new Date())));

  const refImprimir = useRef();

  //Função assionada assim que o botão de imprimir é clicado
  const handlePrint = useReactToPrint({
    content: () => refImprimir.current,
    copyStyles: true,
    documentTitle: "Dados do Dashboard",
  });

  const [jsonDashboard, setJsonDashboard] = useState({
    ordensComAlerta: 0,
    ordensAguardandoJustificativa: 0,
    ordensAguardandoAvaliacao: 0,
    ordensAprovadas: 0,
    indicadorModalidade: [],
    painelAlertas: [],
    statusOperacionais: []
  });

  const GetDashBoard = (_regionais = null) => {
    const regionaisIds = _regionais
      ? _regionais.map(({ regionalId }) => regionalId)
      : regionais.map(({ regionalId }) => regionalId);

    const json_post = {
      inicio,
      fim,
      concessionariaId: session.concessionariaId,
      regionaisId: regionaisIds,
      modalidadeColetaId: modalidade?.modalidadeColetaId
    };

    setshowLoading(true);
    api_POST('dashboard', json_post).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      } else {
        setJsonDashboard(result.data);
      }
    });
  };


  const RedirectOrdem = (statusAvaliacao) => {
    let jsonFiltro;
    if (statusAvaliacao != "Pendente" && statusAvaliacao != "Contestada" && statusAvaliacao != "Justificada")
      jsonFiltro = { statusAvaliacao: statusAvaliacao, dataInicio: inicio, dataFim: fim }
    else
      jsonFiltro = { statusAvaliacao: statusAvaliacao }

    history.push({
      pathname: 'analiseordem',
      state: { detalhes: jsonFiltro }
    });
  }

  const RedirectPainelAlertas = (TipoAlerta) => {
    let jsonFiltro;
    switch (TipoAlerta) {
      case 0:
        jsonFiltro = { statusAvaliacao: "", statusExecucao: ["Em Execução", "Em Pausa", "Destinada"], dataInicio: inicio, dataFim: fim }
        history.push({
          pathname: 'analiseordem',
          state: { detalhes: jsonFiltro }
        });
        break;
      case 1:
        jsonFiltro = { statusAvaliacao: "Reprovada", dataInicio: inicio, dataFim: fim }
        history.push({
          pathname: 'analiseordem',
          state: { detalhes: jsonFiltro }
        });
        break;
      case 2:
        if (session.perfil == "Encarregado de Monitoramento")
          return;
        history.push("localexecucao");
        break;
      case 3:
        if (session.perfil == "Encarregado de Monitoramento")
          return;
        history.push("planostrabalho");
        break;
      case 4:
        if (session.perfil == "Encarregado de Monitoramento")
          return;
        history.push("justificativa");
        break;
      case 5:
        if (session.perfil == "Encarregado de Monitoramento")
          return;
        history.push("recursos");
        break;
      case 6:
        if (session.perfil == "Encarregado de Monitoramento")
          return;
        history.push("recursos");
        break;
      case 7:
        if (session.perfil == "Encarregado de Monitoramento")
          return;
        history.push("localnaoexecucao")
    }
  }

  const loadOptionsRegional = () => {
    api_GET(`regional`).then(result => {
      if (result.status !== 200)
        return showMessage("Aviso", result.message, 'error', null);
      else {
        let _regionais = []
        if (result.data?.length > 0) {
          _regionais = [...result.data];
          setOptionsRegional(_regionais);
          setRegionais(_regionais);
        }
        else {
          _regionais = [{ descricao: "Todos", regionalId: null }];
          setOptionsRegional(_regionais)
          setRegionais(_regionais);
        }

        GetDashBoard(_regionais);
      }
    });
  }

  const loadOptionsModalidade = () => {
    api_GET(`modalidadecoleta/GetListAtivas`).then(result => {
      if (result.status !== 200)
        return showMessage("Aviso", result.message, 'error', null);

      setOptionsModalidade(result.data);
    });
  }

  const handleRegional = (event) => {
    const _regionais = optionsRegional.filter(x => x.regionalId != null);

    if (event.length === 0) {
      setOptionsRegional([..._regionais, { descricao: "Todos", regionalId: null }])
      setRegionais([{ descricao: "Todos", regionalId: null }]);
    } else {
      setOptionsRegional([..._regionais])
      let value = event;
      setRegionais(value);
    }
  }

  useEffect(() => {
    setValue("dataInicio", inicio);
    setValue("dataFim", fim);
    loadOptionsRegional();
    loadOptionsModalidade();
  }, []);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <label style={{ marginRight: "20px" }}>Carregando...</label>
            <Spinner size="sm" color="info" />
          </div>
        </div>
      }
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-7 no-print">
        <Container fluid>
          <div className="header-body">
            <Row>
              <Col md="12" lg="6" xl="8">
                <FormGroup>
                  <label className="form-control-label text-white" htmlFor="input-address" >
                    Divisão Administrativa
                  </label>
                  <Select
                    options={optionsRegional}
                    name="regional"
                    className="form-control-alternative"
                    getOptionLabel={({ descricao }) => descricao}
                    getOptionValue={({ regionalId }) => regionalId}
                    onChange={(value) => { handleRegional(value || []) }}
                    value={optionsRegional.filter(({ regionalId }) => regionais != null && regionais.filter(f => f.regionalId == regionalId).length > 0)}
                    placeholder="Selecione"
                    isMulti="true"
                    styles={{ control: (provided) => ({ ...provided, padding: '5px', }), }}
                  />
                </FormGroup>
              </Col>
              <Col md="6" lg="3" xl="2">
                <FormGroup>
                  <label className="form-control-label text-white" htmlFor="input-address" >
                    Data Início
                  </label>
                  <Input
                    className="form-control-alternative"
                    innerRef={register({ required: true })}
                    defaultValue=""
                    name="dataInicio"
                    placeholder="Data Início"
                    type="date"
                    max={formateDateApi(moment(new Date()))}
                    onBlur={(e) => setInicio(formateDateApi(e.target.value))}
                  />
                  {errors.dataInicio && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                </FormGroup>
              </Col>
              <Col md="6" lg="3" xl="2">
                <FormGroup>
                  <label className="form-control-label text-white" htmlFor="input-address" >
                    Data Fim
                  </label>
                  <Input
                    className="form-control-alternative"
                    innerRef={register({ required: true })}
                    defaultValue=""
                    name="dataFim"
                    placeholder="Data Fim"
                    type="date"
                    max={formateDateApi(moment(new Date()))}
                    onBlur={(e) => setFim(formateDateApi(e.target.value))}
                  />
                  {errors.dataFim && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                </FormGroup>
              </Col>
              <Col md="12" lg="6" xl="6" className="d-flex align-items-end">
                <FormGroup className="flex-grow-1 mb-0">
                  <label className="form-control-label text-white" htmlFor="input-address" >
                    Modalidade de Serviço
                  </label>
                  <Select
                    name="modalidadeColeta"
                    options={optionsModalidade}
                    getOptionLabel={({ descricao }) => descricao}
                    getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                    onChange={(value) => { setModalidade(value) }}
                    value={modalidade != null && optionsModalidade.find(obj => obj.modalidadeColetaId === modalidade.modalidadeColetaId)}
                    placeholder="Todas"
                    styles={{ control: (provided) => ({ ...provided, minWidth: 380, maxWidth: 400 }), }}
                  />
                </FormGroup>
                <div className="d-flex align-items-end ml-3">
                  <Button color="secondary" type="button" onClick={() => GetDashBoard()} className="mr-2">
                    Pesquisar
                  </Button>
                  <Button color="danger" type="button" onClick={handlePrint}>
                    <FontAwesomeIcon icon={faPrint} /> Imprimir
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <div className="row print-padding" ref={refImprimir}>
          <div className="d-none print col-lg-12 col-xl-12">
            <div className="d-flex align-items-center justify-content-between">
              <p>Emitido por: {session.nome}</p>
              <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm:ss")}</p>
            </div>
          </div>
          <div className="col-lg-6 col-xl-3 mb-3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div
                onClick={() => RedirectOrdem("Pendente")}
                style={{ cursor: "pointer" }}
                className="card-body"
              >
                <div className="row">
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0"></h5>
                    <span className="h2 font-weight-bold mb-0">
                      {jsonDashboard.ordensComAlerta}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-gradient-warning text-white rounded-circle shadow">
                      <FontAwesomeIcon icon={faTriangleExclamation} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <small>Ordens Com Alerta na Execução</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-xl-3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div
                onClick={() => RedirectOrdem("Contestada")}
                style={{ cursor: "pointer" }}
                className="card-body"
              >
                <div className="row">
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0"></h5>
                    <span className="h2 font-weight-bold mb-0">
                      {jsonDashboard.ordensAguardandoJustificativa}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-gradient-primary text-white rounded-circle shadow">
                      <FontAwesomeIcon icon={faCheck} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <small>Ordens Aguardando Justificativa</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-xl-3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div
                onClick={() => RedirectOrdem("Justificada")}
                style={{ cursor: "pointer" }}
                className="card-body"
              >
                <div className="row">
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0"></h5>
                    <span className="h2 font-weight-bold mb-0">
                      {jsonDashboard.ordensAguardandoAvaliacao}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-gradient-danger text-white rounded-circle shadow">
                      <FontAwesomeIcon icon={faUserShield} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <small>Ordens Aguardando Avaliação</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-xl-3">
            <div className="card card-stats mb-4 mb-xl-0">
              <div
                onClick={() => RedirectOrdem("Aprovada")}
                style={{ cursor: "pointer" }}
                className="card-body"
              >
                <div className="row">
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0"></h5>
                    <span className="h2 font-weight-bold mb-0">
                      {jsonDashboard.ordensAprovadas}
                    </span>
                  </div>
                  <div className="col-auto">
                    <div className="icon icon-shape bg-gradient-success text-white rounded-circle shadow">
                      <FontAwesomeIcon icon={faCheckDouble} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <small>Ordens Aprovadas</small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Painel de Status Operacionais */}
          <div className="col-lg-12 col-xl-12">
            <StatusOperacionaisTable
              periodo={{ dataInicio: inicio, dataFim: fim }}
              concessionariaId={session.concessionariaId}
              regionaisId={regionais.map(({ regionalId }) => regionalId)}
              modalidadeColetaId={modalidade?.modalidadeColetaId}
            />
          </div>

          {/* Painel de Alerta */}
          <div className="col-lg-12 col-xl-12 mt-1 mb-2 w-100">
            <div className="card shadow">
              <h3 className="pl-4 pt-2">Painel de Alertas</h3>
              <div className="table-responsive">
                <table className="table ">
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: "80%" }}>Descrição</th>
                      <th style={{ width: "20%" }}>Qtd</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jsonDashboard != null &&
                      jsonDashboard.painelAlertas.map((m, key) => (
                        <tr
                          key={key}
                          style={{ cursor: "pointer" }}
                          onClick={() => RedirectPainelAlertas(m.tipoAlerta)}
                        >
                          <td>{m.descricao}</td>
                          <td>{m.qtd}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Painel de Indicador Por Modalidade de Serviço */}
          <div className="col-lg-12 col-xl-12">
            <div className="card shadow">
              <h3 className="pl-4 pt-2">Indicador Por Modalidade de Serviço</h3>
              <div className="table-responsive align-items-center table-flush">
                <table className="table table-responsive">
                  <thead className="thead-light">
                    <tr className="">
                      <th style={{ width: "30%", whiteSpace: "normal" }} className="align-middle">Modalidade</th>
                      <th style={{ width: "20%", whiteSpace: "normal" }} className="align-middle">Ordens Programadas</th>
                      <th style={{ width: "20%", whiteSpace: "normal" }} className="align-middle">Ordens Finalizadas</th>
                      <th style={{ width: "20%", whiteSpace: "normal" }} className="align-middle">Locais Programados</th>
                      <th style={{ width: "20%", whiteSpace: "normal" }} className="align-middle">Locais Executados</th>
                      <th style={{ width: "20%", whiteSpace: "normal" }} className="align-middle">Locais Parcialmente Executado</th>
                      <th style={{ width: "20%", whiteSpace: "normal" }} className="align-middle">Locais Não Executados</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jsonDashboard != null &&
                      jsonDashboard.indicadorModalidade.map((m) => (
                        <tr key={m.modalidadeColeta_Descricao}>
                          <td style={{ width: "30%", whiteSpace: "normal" }}>
                            {m.modalidadeColeta_Descricao}
                          </td>
                          <td style={{ width: "20%", whiteSpace: "normal" }}>
                            {m.qtdOrdensProgramadas}
                          </td>
                          <td style={{ width: "20%", whiteSpace: "normal" }}>
                            {m.qtdOrdensFinalizadas}
                          </td>
                          <td style={{ width: "20%", whiteSpace: "normal" }}>
                            {m.qtdPontosProgramados}
                          </td>
                          <td style={{ width: "20%", whiteSpace: "normal" }}>
                            {m.qtdPontosExecutados}
                          </td>
                          <td style={{ width: "20%", whiteSpace: "normal" }}>
                            {m.qtdPontosParcialmente}
                          </td>
                          <td style={{ width: "20%", whiteSpace: "normal" }}>
                            {m.qtdPontosNaoExecutados}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>



        </div>
      </Container>
    </>
  );
}